import {PatientLookupActions} from "../const/ActionsConst";

const initialState = {
    stepNumber: 1
};

const currentStep = (state = initialState, action) => {
    switch (action.type) {
        case PatientLookupActions.SET_CURRENT_STEP:
            return {
                ...state,
                stepNumber: action.step
            };
        default:
            return state;
    }
};

export default currentStep;